import { createTheme } from "@material-ui/core/styles";
import paper from "./Paper";
import breakpoints from "./breakpoints";
import dialog from "./dialog";
import palette from "./palette";
import shape from "./shape";
import typography from "./typography";

export const theme = createTheme({
  palette,
  typography,
  breakpoints,
  dialog,
  paper,
  shape,
  overrides: {
    MuiCssBaseline: {
      "@global": {
        body: {
          fontFamily: "Poppins, sans-serif",
        },
      },
    },
  },
});
